import { render, staticRenderFns } from "./integralMallDecoration.vue?vue&type=template&id=0b916e18&scoped=true"
import script from "./integralMallDecoration.vue?vue&type=script&lang=js"
export * from "./integralMallDecoration.vue?vue&type=script&lang=js"
import style0 from "./integralMallDecoration.vue?vue&type=style&index=0&id=0b916e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b916e18",
  null
  
)

export default component.exports